import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["overlay", "content"]

  showLoading() {
    this.overlayTarget.classList.remove("d-none")
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("d-none")
    }
  }

  hideLoading() {
    this.overlayTarget.classList.add("d-none")
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("d-none")
    }
  }
}